import { useRef, useState } from "react";
import { trackEvent } from "../analytics";
import { CONFIG } from "../i18n";
import { LIMPIEZA, LIMPIEZA_EN } from "../limpiezaCopy";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const LimpiezaPage = ({ lang }) => {
  const c = lang === "en" ? LIMPIEZA_EN : LIMPIEZA;
  const formRef = useRef(null);
  const [error, setError] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const f = formRef.current;
    const name = f.elements.limpName.value.trim();
    const wa = f.elements.limpWa.value.trim();
    const need = f.elements.limpNeed.value.trim();
    if (!name || !wa || !need) {
      setError(true);
      return;
    }
    setError(false);
    trackEvent("generate_lead", { metodo: "whatsapp" }, "Lead");
    const msg = `${c.form.greeting}\n\nTu nombre: ${name}\nTu WhatsApp: ${wa}\n¿Qué necesitas?: ${need}`;
    window.open(`https://wa.me/${CONFIG.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
  };

  return (
    <main data-testid="limpieza-page">
      <section className="limp-hero grain">
        <div className="limp-hero-inner">
          <p className="eyebrow lt" data-testid="limpieza-eyebrow">
            <span className="eyebrow-rule" />
            {c.eyebrow}
          </p>
          <h1 data-testid="limpieza-headline">
            {c.h1a} <em>{c.h1b}</em>
          </h1>
          <p className="lead lt-2">{c.lead}</p>
          <a className="btn-gold" href="#cotizar" data-testid="limpieza-cta" onClick={() => trackEvent("cta_click", { texto: c.cta })}>
            {c.cta} <span className="arr">↗</span>
          </a>
        </div>
      </section>

      <section className="limp-section">
        <div className="limp-inner">
          <h2>{c.story.h}</h2>
          <p className="limp-story-p">{c.story.p}</p>
        </div>
      </section>

      <section className="limp-section limp-tinted">
        <div className="limp-inner">
          <h2>{c.knows.h}</h2>
          <ul className="limp-knows-list">
            {c.knows.items.map((it, i) => (
              <li key={i}>{it}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="limp-section">
        <div className="limp-inner">
          <h2>{c.services.h}</h2>
          <div className="limp-grid">
            {c.services.cards.map((s, i) => (
              <article className="limp-card" key={i} data-testid={`limpieza-service-${i + 1}`}>
                <h3>{s.h}</h3>
                <p>{s.p}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="limp-section limp-tinted">
        <div className="limp-inner">
          <h2>{c.built.h}</h2>
          <div className="limp-grid">
            {c.built.projects.map((p, i) => (
              <article className="limp-card limp-project" key={i} data-testid={`limpieza-project-${slug(p.name)}`}>
                <div className="project-media">
                  <img src={p.img} alt={p.alt} width={p.w} height={p.h} loading="lazy" />
                </div>
                <h3>{p.name}</h3>
                <p>{p.desc}</p>
                <span className="status mono">{p.status}</span>
                {p.url ? (
                  <a className="textlink" href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`limpieza-link-${slug(p.name)}`}>
                    {p.link} <span className="arr">↗</span>
                  </a>
                ) : null}
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="limp-section">
        <div className="limp-inner">
          <h2>{c.steps.h}</h2>
          <ol className="limp-steps">
            {c.steps.items.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ol>
        </div>
      </section>

      <section className="limp-section limp-tinted limp-faq">
        <div className="limp-inner">
          <h2>{c.faq.h}</h2>
          {c.faq.items.map((f, i) => (
            <div className="limp-faq-item" key={i} data-testid={`limpieza-faq-${i + 1}`}>
              <h3>{f.q}</h3>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="limp-form-section grain" id="cotizar" data-testid="limpieza-form-section">
        <h2>{c.form.h}</h2>
        <form ref={formRef} className="brief limp-brief" noValidate onSubmit={submit} data-testid="limpieza-form">
          <div className="field">
            <label htmlFor="l-name">{c.form.name}</label>
            <input id="l-name" name="limpName" type="text" autoComplete="name" data-testid="limpieza-input-name" />
          </div>
          <div className="field">
            <label htmlFor="l-wa">{c.form.whatsapp}</label>
            <input id="l-wa" name="limpWa" type="tel" autoComplete="tel" data-testid="limpieza-input-whatsapp" />
          </div>
          <div className="field">
            <label htmlFor="l-need">{c.form.need}</label>
            <input id="l-need" name="limpNeed" type="text" placeholder={c.form.needPh} data-testid="limpieza-input-need" />
          </div>
          <p className="form-error" role="alert" hidden={!error} data-testid="limpieza-form-error">{error ? c.form.required : ""}</p>
          <div className="actions form-actions">
            <button type="submit" className="btn-gold" data-testid="limpieza-btn-send">
              {c.form.send} <span className="arr">↗</span>
            </button>
          </div>
          <small className="contact-note lt-2">{c.form.note}</small>
        </form>
        <p className="limp-close serif-i">{c.close}</p>
      </section>
    </main>
  );
};

export default LimpiezaPage;
